// Raahatut tiedostot ja kansiot listaksi [{ file, folder }]; folder on kansiopolku raahatun kansion nimestä alkaen
// (null juuressa). Käyttöjärjestelmien metatiedostot (.DS_Store, Thumbs.db) jätetään pois kuten zipin purussa.

const skipped = name => name.startsWith('.') || name.toLowerCase() === 'thumbs.db';

function fileOf(entry) {
  return new Promise((resolve, reject) => entry.file(resolve, reject));
}

// readEntries palauttaa kansion sisällön erissä (Chrome 100 kerrallaan), joten luetaan kunnes erä on tyhjä
async function entriesOf(directory) {
  const reader = directory.createReader();
  const all = [];
  for (;;) {
    const batch = await new Promise((resolve, reject) => reader.readEntries(resolve, reject));
    if (batch.length === 0) return all;
    all.push(...batch);
  }
}

async function collect(entry, folder, out) {
  if (skipped(entry.name)) return;
  if (entry.isFile) {
    out.push({ file: await fileOf(entry), folder });
  } else if (entry.isDirectory) {
    const path = folder ? `${folder}/${entry.name}` : entry.name;
    for (const child of await entriesOf(entry)) await collect(child, path, out);
  }
}

export async function droppedFiles(dataTransfer) {
  // Kohteet luetaan ennen ensimmäistä awaitia: DataTransfer tyhjenee, kun drop-käsittelijä palaa
  const entries = Array.from(dataTransfer.items || [])
    .filter(item => item.kind === 'file')
    .map(item => (item.webkitGetAsEntry ? item.webkitGetAsEntry() : null));
  if (entries.length === 0 || entries.some(e => !e)) {
    return Array.from(dataTransfer.files || []).map(file => ({ file, folder: null }));
  }
  const out = [];
  for (const entry of entries) await collect(entry, null, out);
  return out;
}

export function chosenFiles(fileList) {
  return Array.from(fileList || [])
    .filter(file => !skipped(file.name))
    .map(file => ({ file, folder: null }));
}
